/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { getTarjetas, getTarjetasBancos } from "../../services/TarjetaBancoService";
import { DatePicker } from "@mui/x-date-pickers";
import { saveAcuerdoTarjetaBanco } from "../../services/TarjetaBancoAcuerdoService";
import { format, isValid } from "date-fns";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  idTarjeta: null,
  idTarjetaBanco: null,
  bancoEntidad: "",
  fechaVigenciaDesde: null,
  fechaVigenciaHasta: null,
  cantidadCuotas: 0,
  descripcion: "",
  porcentajeInteres: 0,
  porcentajeDescuento: 0,
  cft: 0,
  tea: 0,
  mensaje: "",
  lunes: false,
  martes: false,
  miercoles: false,
  jueves: false,
  viernes: false,
  sabado: false,
  domingo: false,
  observaciones: "",
  descripcionOdoo: "",
};

const nameItemText = "Acuerdo: Tarjeta - Banco/Entidad ";
const itemGender = "M";
//
// ########################################################################### 
//
const TarjetaBancoAcuerdoDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(itemCrud);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [valueACTarjetas, setValueACTarjetas] = useState
    (
      itemCrud.tarjeta
    )
  const [inputValueACTarjetas, setInputValueACTarjetas] = useState("");
  const [tarjetas, setTarjetas] = useState([]);

  const [valueACTarjetasBancos, setValueACTarjetasBancos] = useState
    (
      itemCrud.tarjetaBanco
    )
  const [inputValueACTarjetasBancos, setInputValueACTarjetasBancos] = useState("");
  const [tarjetasBancos, setTarjetasBancos] = useState([]);

  //
  // ################################################################################
  //
  useEffect(() => {
    loadTarjetas();

    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setValueACTarjetasBancos(itemCrud.tarjetaBanco);
      setInputValueACTarjetasBancos(itemCrud.tarjetaBanco.label);
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (valueACTarjetas) {
      if (itemCrud && itemCrud.tarjeta) {
        if (itemCrud.tarjeta.id !== valueACTarjetas.id || (itemCrud.tarjetaBanco !== valueACTarjetasBancos)) {
          setValueACTarjetasBancos(null);
        }
        loadTarjetaBanco(valueACTarjetas.id);
      } else {
        setValueACTarjetasBancos(null);
      }
      loadTarjetaBanco(valueACTarjetas.id);
    }
  }, [valueACTarjetas])
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaVigenciaDesde = (fecha) => {

    setItemCrudLocal({
      ...itemCrudLocal,
      fechaVigenciaDesde: fecha ?? null
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaVigenciaHasta = (fecha) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      fechaVigenciaHasta: fecha ?? null
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {

    if (actionCrud === "new" || actionCrud === "update") {
      if (valueACTarjetas === null || valueACTarjetas === undefined) {
        setMessage({
          messageText: "Debe seleccionar una tarjeta",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
      if (valueACTarjetasBancos === null || valueACTarjetasBancos === undefined) {
        setMessage({
          messageText: "Debe seleccionar un Banco/Entidad",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
      if (
        !isValid(itemCrudLocal.fechaVigenciaDesde)
        || (itemCrudLocal.fechaVigenciaDesde === null)
        || !isValid(itemCrudLocal.fechaVigenciaHasta)
        || (itemCrudLocal.fechaVigenciaHasta === null)
      ) {
        setMessage({
          messageText: "La Fecha ingresada no es válida",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.fechaVigenciaHasta &&
        itemCrudLocal.fechaVigenciaDesde > itemCrudLocal.fechaVigenciaHasta
      ) {
        setMessage({
          messageText: "La Fecha Desde no puede ser Posterio a la Fecha Hasta",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {
    let _itemCrud = {
      id_tarjeta_banco: valueACTarjetasBancos.id,
      fecha_vigencia_desde: format(itemCrudLocal.fechaVigenciaDesde, "yyyy/MM/dd"),
      fecha_vigencia_hasta: format(itemCrudLocal.fechaVigenciaHasta, "yyyy/MM/dd"),
      cantidad_cuotas: itemCrudLocal.cantidadCuotas ? +itemCrudLocal.cantidadCuotas : 1,
      descripcion: itemCrudLocal.descripcion,
      porcentaje_interes: itemCrudLocal.porcentajeInteres ? +itemCrudLocal.porcentajeInteres : 0,
      porcentaje_descuento: itemCrudLocal.porcentajeDescuento ? +itemCrudLocal.porcentajeDescuento : 0,
      costo_financiero_total: itemCrudLocal.cft ? +itemCrudLocal.cft : 0,
      tasa_efectiva_anual: itemCrudLocal.tea ? +itemCrudLocal.tea : 0,
      mensaje: itemCrudLocal.mensaje,
      lunes: itemCrudLocal.lunes,
      martes: itemCrudLocal.martes,
      miercoles: itemCrudLocal.miercoles,
      jueves: itemCrudLocal.jueves,
      viernes: itemCrudLocal.viernes,
      sabado: itemCrudLocal.sabado,
      domingo: itemCrudLocal.domingo,
      observaciones: itemCrudLocal.observaciones,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    setIsDoingSomething(true);
    const response = await saveAcuerdoTarjetaBanco(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  const loadTarjetas = async () => {

    setIsDoingSomething(true);
    const response = await getTarjetas();
    setIsDoingSomething(false);

    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: (item.marca).toUpperCase() + " - " + (item.tipo).toUpperCase(),
        });
      });
      setTarjetas(_var);
    } else {
      setTarjetas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const loadTarjetaBanco = async (idTarjeta) => {

    setIsDoingSomething(true);
    const response = await getTarjetasBancos(({ idTarjeta: idTarjeta }));
    setIsDoingSomething(false);

    if (response.ok) {

      let _response = response.data.data;
      let _val = [];
      _response.forEach((item) => {
        _val.push({
          id: item.id,
          label: (item.banco_entidad).toUpperCase()
        });
      });
      setTarjetasBancos(_val);

      setItemCrudLocal({
        ...itemCrudLocal,
        descripcionOdoo: _response[0].descripcion_odoo
      });

    } else {
      setTarjetasBancos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Autocomplete
                id="idTarjeta"
                sx={{ width: "100%" }}
                size="small"
                value={valueACTarjetas ?? null} // Asegurar que nunca sea undefined
                onChange={(event, newValue) => {
                  setValueACTarjetas(newValue);
                }}
                inputValue={inputValueACTarjetas}
                onInputChange={(event, newInputValue) => {
                  setInputValueACTarjetas(newInputValue);
                }}
                options={tarjetas}
                renderInput={(params) => <TextField {...params} label="Tarjeta" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                getOptionLabel={(option) => option.label || ""}
                disableClearable={true}
              />

            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                id="idTarjetaBanco"
                sx={{ width: "100%" }}
                size="small"
                value={valueACTarjetasBancos ?? null}
                onChange={(event, newValue) => {
                  setValueACTarjetasBancos(newValue);
                }}
                inputValue={inputValueACTarjetasBancos}
                onInputChange={(event, newInputValue) => {
                  setInputValueACTarjetasBancos(newInputValue);
                }}
                options={tarjetasBancos}
                renderInput={(params) => <TextField {...params} label="Banco/Entidad" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                getOptionLabel={(option) => option.label || ""}
                disableClearable={true}
              />

            </Grid>

            <Grid item xs={4}>
              <DatePicker
                sx={{
                  width: "100%",
                  mb: 1,
                  "& .MuiInputLabel-root": {
                    transform: "translate(14px, 9px) scale(1)",
                  },
                  "& .MuiInputBase-root": {
                    paddingRight: "10px",
                  },
                  "& .MuiInputLabel-shrink": {
                    transform: "translate(14px, -8px) scale(0.75)",
                  },
                }}
                id="fechaVigenciaDesde"
                label="Vigencia Desde"
                variant="outlined"
                size="small"
                name="fechaVigenciaDesde"
                value={itemCrudLocal.fechaVigenciaDesde ?? null}
                format="dd/MM/yyyy"
                onChange={handleChangeFechaVigenciaDesde}
                slots={{ textField: TextField }}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { width: "100%" },
                  },
                }}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={4}>
              <DatePicker
                sx={{
                  width: "100%",
                  mb: 1,
                  "& .MuiInputLabel-root": {
                    transform: "translate(14px, 9px) scale(1)",
                  },
                  "& .MuiInputBase-root": {
                    paddingRight: "10px",
                  },
                  "& .MuiInputLabel-shrink": {
                    transform: "translate(14px, -8px) scale(0.75)",
                  },
                }}
                id="fechaVigenciaHasta"
                label="Vigencia Hasta"
                variant="outlined"
                size="small"
                name="fechaVigenciaHasta"
                value={itemCrudLocal.fechaVigenciaHasta ?? null}
                format="dd/MM/yyyy"
                onChange={handleChangeFechaVigenciaHasta}
                slots={{ textField: TextField }}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { width: "100%" },
                  },
                }}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="cantidadCuotas"
                label="Cantidad de Cuotas"
                variant="outlined"
                size="small"
                name="cantidadCuotas"
                value={itemCrudLocal.cantidadCuotas}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion"
                label="Descripción"
                variant="outlined"
                size="small"
                name="descripcion"
                value={itemCrudLocal.descripcion}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="porcentajeInteres"
                label="% de Interés"
                variant="outlined"
                size="small"
                name="porcentajeInteres"
                value={itemCrudLocal.porcentajeInteres ? itemCrudLocal.porcentajeInteres : 0}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="porcentajeDescuento"
                label="% de Descuento"
                variant="outlined"
                size="small"
                name="porcentajeDescuento"
                value={itemCrudLocal.porcentajeDescuento ? itemCrudLocal.porcentajeDescuento : 0}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="cft"
                label="C.F.T"
                variant="outlined"
                size="small"
                name="cft"
                value={itemCrudLocal.cft ? itemCrudLocal.cft : 0}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="tea"
                label="T.E.A"
                variant="outlined"
                size="small"
                name="tea"
                value={itemCrudLocal.tea ? itemCrudLocal.tea : 0}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="mensaje"
                label="Mensaje"
                variant="outlined"
                size="small"
                name="mensaje"
                value={itemCrudLocal.mensaje}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={12}>
              <FormLabel
                component="legend"
                sx={{ fontWeight: "bold", color: "text.primary", fontSize: "0.9rem", mt: 1 }}
              >
                Validez
              </FormLabel>
            </Grid>

            <Grid item xs={12}>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={itemCrudLocal.lunes ?? false}
                    onChange={handleChange}
                    name="lunes"
                    sx={{ ml: 2 }}
                    color="primary"
                    disabled={
                      actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                    }
                  />
                }
                label="Lunes"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={itemCrudLocal.martes ?? false}
                    onChange={handleChange}
                    name="martes"
                    color="primary"
                    disabled={
                      actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                    }
                  />
                }
                label="Martes"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={itemCrudLocal.miercoles ?? false}
                    onChange={handleChange}
                    name="miercoles"
                    color="primary"
                    disabled={
                      actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                    }
                  />
                }
                label="Miércoles"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={itemCrudLocal.jueves ?? false}
                    onChange={handleChange}
                    name="jueves"
                    color="primary"
                    disabled={
                      actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                    }
                  />
                }
                label="Jueves"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={itemCrudLocal.viernes ?? false}
                    onChange={handleChange}
                    name="viernes"
                    sx={{ ml: 2 }}
                    color="primary"
                    disabled={
                      actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                    }
                  />
                }
                label="Viernes"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={itemCrudLocal.sabado ?? false}
                    onChange={handleChange}
                    name="sabado"
                    color="primary"
                    disabled={
                      actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                    }
                  />
                }
                label="Sábado"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={itemCrudLocal.domingo ?? false}
                    onChange={handleChange}
                    name="domingo"
                    color="primary"
                    disabled={
                      actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                    }
                  />
                }
                label="Domingo"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={actionCrud === "disable" ? "error" : "primary"}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog >

      < WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default TarjetaBancoAcuerdoDialog;
